<div class="joker-badge">
  <fa-icon icon="{{ icon }}"></fa-icon>
</div>
